// ============================================================================
// Widget — Top Movers
// Branches with the largest swing in collection MoM, plus slippage signal.
// ============================================================================
import React from 'react';
import WidgetShell from './WidgetShell';
import { mockTopMovers, fmtAmount, fmtDeltaPct } from '../executiveMockData';

const TopMoversWidget: React.FC = () => (
  <WidgetShell
    title="Top Movers — Branch"
    subtitle="Collection MoM swing + new accounts slipped past 30 DPD this period"
  >
    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.78rem' }}>
      <thead>
        <tr style={{ background: '#dbeafe' }}>
          <th style={th}>#</th>
          <th style={th}>Branch</th>
          <th style={{ ...th, textAlign: 'right' }}>Collected</th>
          <th style={{ ...th, textAlign: 'right' }}>MoM Δ</th>
          <th style={{ ...th, textAlign: 'right' }}>Slipped</th>
        </tr>
      </thead>
      <tbody>
        {mockTopMovers.map(m => {
          const isUp = m.deltaPct >= 0;
          return (
            <tr key={m.branch} style={{ borderTop: '1px solid var(--border-color)' }}>
              <td style={td}>{m.rank}</td>
              <td style={td}><strong>{m.branch}</strong></td>
              <td style={{ ...td, textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{fmtAmount(m.collectedThisPeriod)}</td>
              <td style={{ ...td, textAlign: 'right', fontVariantNumeric: 'tabular-nums', color: isUp ? '#16a34a' : '#dc2626', fontWeight: 600 }}>
                {fmtDeltaPct(m.deltaPct)}
              </td>
              <td style={{ ...td, textAlign: 'right', fontVariantNumeric: 'tabular-nums', color: m.slippedAccountsThisPeriod > 20 ? '#dc2626' : 'var(--text-primary)' }}>
                {m.slippedAccountsThisPeriod}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </WidgetShell>
);

const th: React.CSSProperties = {
  textAlign: 'left', padding: '0.45rem 0.55rem', fontWeight: 600,
  color: 'var(--text-secondary)', borderBottom: '2px solid var(--border-color)',
  fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '0.04em',
};
const td: React.CSSProperties = { padding: '0.5rem 0.55rem', verticalAlign: 'top' };

export default TopMoversWidget;
